import axios from "axios";  
import { BASE_URL } from "../../assets/constant";
import { createHeaders } from "../../utils/Utils";

 

export const getUserListAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}admin/get-users`, data, headers);
};

/** Admin panel accounts from `login` table (not registered app `users`). */
export const getAdminLoginUsersAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}admin/get-login-users`, data, headers);
};

export const updateAdminLoginUserAPI = async (data) => {
  const headers = createHeaders();
  return await axios.put(`${BASE_URL}admin/login-users/update`, data, headers);
};
export const createUserAPI = async (data) => {  
      const headers = createHeaders()
  return await axios.post(`${BASE_URL}superuser/users`,data, headers);
};

/** Admin users — POST /api/create-user body: { username, password, role, status, permissions } */
export const createAdminUserAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}api/create-user`, data, {
    ...headers,
    /** So HTTP 500 + JSON body still resolves; UI can read message instead of only .catch */
    validateStatus: () => true,
  });
};
export const updateUserAPI = async (data) => {  
      const headers = createHeaders()
  return await axios.put(`${BASE_URL}superuser/users/update`,data, headers);
};
export const updateQuestions = async (data) => {  
      const headers = createHeaders()
  return await axios.post(`${BASE_URL}admin/chats/approve`,data, headers);
};
// export const questionStatusUpdate = async (data) => {  
//       const headers = createHeaders()
//   return await axios.get(`${BASE_URL}admin/chats/approved`,data, headers);
// };
export const questionStatusUpdate = async (data) => {  
      const headers = createHeaders()
  return await axios.put(`${BASE_URL}admin/chats/toggle`,data, headers);
};
export const addQuestionAPI = async (data) => {  
      const headers = createHeaders()
  return await axios.post(`${BASE_URL}add`,data, headers);
};
export const getCategoryAPI = async (data) => {  
      const headers = createHeaders()
  return await axios.get(`${BASE_URL}category`, headers); 
};
export const updateQuestionAPI = async (data) => {  
      const headers = createHeaders()
  return await axios.post(`${BASE_URL}admin/edit/1`,data, headers);
};